import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './Style.css';
import { ImCross } from 'react-icons/im';
import ReactTooltip from 'react-tooltip';
import COLOR_CODES from 'asset/json/colorcodes.json';
import { Radio } from '@material-ui/core';
import * as DOMPurify from 'dompurify';

const ProductFilter = ({
	filter,
	onChange,
	filteroptions,
	onRemove,
	onRemoveAll,
}) => {
	const [hideFilter, setHideFilter] = useState({});
	const [colorTipName, setColorTipName] = useState({});
	const handlecolorName = (color_Code) => {
		if (color_Code) {
			let Obj = {};

			COLOR_CODES &&
				COLOR_CODES.forEach((codes) => {
					if (codes.code === color_Code) {
						Obj = codes;
					}
				});
			setColorTipName(Obj);
			// console.log('**************code', Obj);
		}
	};
	useEffect(() => {
		// onRemoveAll();
	}, [filteroptions]);
	const showHideFilter = (index) => {
		if (hideFilter[index]) {
			let hf = { ...hideFilter };
			delete hf[index];
			setHideFilter({ ...hf });
		} else {
			setHideFilter({ ...hideFilter, [index]: true });
		}
	};
	const handleradioblur = () => {
		// console.log('BLUR RADIO');
		document.getElementById('radio-blur').blur();
	};
	return (
		<>
			<div
				className='sidebar-wrapper mt-5'
				style={{ borderBottom: '0px none rgb(119, 119, 119)', width: '25rem' }}
			>
				<div className='widget'>
					<div className='fiter-clear-all'>
						{Object.keys(filteroptions).length > 0 && (
							<h3 className='widget-title'>Filter By</h3>
						)}
						{Object.keys(filteroptions).length > 0 && (
							<button
								className='Clear-all'
								onClick={() => {
									setHideFilter({});
									onRemoveAll();
								}}
							>
								Clear All
							</button>
						)}
					</div>
					{Object.keys(filteroptions).map((k, index) => (
						<div key={index} className='flexcrossdiv'>
							<button
								onClick={() => {
									onRemove(k);
									setHideFilter({});
								}}
								className='flexcrossbtn'
							>
								<ImCross className='iconfiltercross' />{' '}
								<span className='boldheadingselected'>
									{filteroptions[k].name + ': '}
								</span>{' '}
								<span
									dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(filteroptions[k].label) }}
								></span>
							</button>
						</div>
					))}
				</div>
				{filter.map((item, index) => (
					<>
						{item.code !== 'price' && (
							<div key={index} className='widget'>
								<h3 className='widget-title'>
									<a
										data-toggle='collapse'
										role='button'
										aria-expanded='true'
										aria-controls='widget-body'
										className={hideFilter[index] ? 'collapsed' : ''}
										onClick={() => showHideFilter(index)}
									>
										{item.name}
									</a>
								</h3>
								<div
									className={hideFilter[index] ? 'collapse' : 'collapse show'}
									id={'widget-body-' + index}
								>
									<div className='widget-body custom-control custom-radio'>
										<ul className='cat-list'>
											{item.values &&
												// item.code !== 'price' &&
												item.values.map((raw, i) => (
													<li
														key={i}
														onClick={() => {
															onChange(item.code, {
																name: item.name,
																value: raw.value,
																label: raw.label,
															});
															setHideFilter({});
															handleradioblur();
														}}
													>
														<a>
															<span
																dangerouslySetInnerHTML={{
																	__html: DOMPurify.sanitize(raw.label),
																}}
															></span>

															<input
																type='radio'
																name='radio'
																id='radio-blur'
																checked={false}
																onClick={(e) => handleradioblur(e)}
															/>
														</a>
													</li>
												))}
										</ul>
									</div>
								</div>
							</div>
						)}
					</>
				))}
			</div>
		</>
	);
};
const data = [
	{
		question: 'Type',
		answer: ' Long Sleves',
	},
	{
		question: 'Type',
		answer: ' hey ',
	},
];

export default ProductFilter;
